import { useQuery } from '@tanstack/react-query';
import {
  getOperationalMetrics,
  getUsersPerformance,
  getStagePerformance,
  type OperationalMetrics,
  type UserPerformance,
  type StagePerformance,
} from '../../../services/workflowService';

interface UseGestaoKPIsParams {
  organizationId?: string;
}

interface UseGestaoKPIsResult {
  metrics: OperationalMetrics | null;
  usersPerformance: UserPerformance[];
  stagePerformance: StagePerformance[];
  isLoading: boolean;
  error: Error | null;
}

export function useGestaoKPIs(params: UseGestaoKPIsParams): UseGestaoKPIsResult {
  const { organizationId } = params;

  const metricsQuery = useQuery({
    queryKey: ['gestao', organizationId, 'metrics'],
    enabled: Boolean(organizationId),
    queryFn: () => getOperationalMetrics(organizationId!),
    staleTime: 30_000,
  });

  const usersQuery = useQuery({
    queryKey: ['gestao', organizationId, 'users-performance'],
    enabled: Boolean(organizationId),
    queryFn: () => getUsersPerformance(organizationId!, 10),
    staleTime: 60_000,
  });

  const stageQuery = useQuery({
    queryKey: ['gestao', organizationId, 'stage-performance'],
    enabled: Boolean(organizationId),
    queryFn: () => getStagePerformance(organizationId!),
    staleTime: 60_000,
  });

  return {
    metrics: metricsQuery.data ?? null,
    usersPerformance: usersQuery.data ?? [],
    stagePerformance: stageQuery.data ?? [],
    isLoading: metricsQuery.isPending,
    error: metricsQuery.error ?? null,
  };
}
